import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "21",
  viewBox: "0 0 20 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M7.49935 6.33366C7.49935 5.87342 7.87245 5.50033 8.33268 5.50033H11.666C12.1263 5.50033 12.4993 5.87342 12.4993 6.33366C12.4993 6.7939 12.1263 7.16699 11.666 7.16699H8.33268C7.87245 7.16699 7.49935 6.7939 7.49935 6.33366Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M14.5532 17.1647C15.7189 17.1647 16.664 16.2196 16.664 15.0539C16.664 13.8882 15.7189 12.9431 14.5532 12.9431C13.3875 12.9431 12.4424 13.8882 12.4424 15.0539C12.4424 16.2196 13.3875 17.1647 14.5532 17.1647ZM14.5532 18.8313C16.6394 18.8313 18.3306 17.1401 18.3306 15.0539C18.3306 12.9677 16.6394 11.2765 14.5532 11.2765C12.467 11.2765 10.7758 12.9677 10.7758 15.0539C10.7758 17.1401 12.467 18.8313 14.5532 18.8313Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M3.33268 4.66699C3.33268 4.20675 3.70578 3.83366 4.16602 3.83366H15.8327C16.2929 3.83366 16.666 4.20675 16.666 4.66699V8.83366C16.666 9.2939 17.0391 9.66699 17.4993 9.66699C17.9596 9.66699 18.3327 9.2939 18.3327 8.83366V4.66699C18.3327 3.28628 17.2134 2.16699 15.8327 2.16699H4.16602C2.7853 2.16699 1.66602 3.28628 1.66602 4.66699V16.3337C1.66602 17.7144 2.7853 18.8337 4.16602 18.8337H8.33268C8.79292 18.8337 9.16602 18.4606 9.16602 18.0003C9.16602 17.5401 8.79292 17.167 8.33268 17.167H4.16602C3.70578 17.167 3.33268 16.7939 3.33268 16.3337V4.66699Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M16.8092 12.798C17.1346 13.1234 17.1346 13.6511 16.8092 13.9765L13.4758 17.3098C13.1504 17.6353 12.6228 17.6353 12.2973 17.3098C11.9719 16.9844 11.9719 16.4568 12.2973 16.1313L15.6307 12.798C15.9561 12.4726 16.4837 12.4726 16.8092 12.798Z",
  fill: "currentColor"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _hoisted_5
  ]))
}